import { FC } from 'react';
import Tooltip from '../tooltip/Tooltip';
import { TOOLTIP_MESSAGE_CONSTANTS } from '../../constants/common';
import './specimenLotInfo.scss';

type SpecimenLotInfoProps = {
  specimenId: number;
  lotNumber?: string;
  freezeDate?: Date;
};

const SpecimenLotInfo: FC<SpecimenLotInfoProps> = ({ specimenId, lotNumber, freezeDate }): JSX.Element => {
  return (
    <div className="specimen-lot-info">
      <div>
        {freezeDate ? `${new Date(freezeDate.toString()).toLocaleDateString()} - ` : ''}
        {specimenId}
      </div>
      {lotNumber && (
        <div>
          ({lotNumber} <Tooltip>{TOOLTIP_MESSAGE_CONSTANTS.USER_LOT_NUMBER}</Tooltip>)
        </div>
      )}
    </div>
  );
};
export default SpecimenLotInfo;
